import React from 'react'

function Confi() {
  return (
    <div className='text-center m-5'>
      <h3>your order placed</h3>
    </div>
  )
}

export default Confi;
